<div class="row">
    <div class="col-6 col-lg-6 col-xl-3">
        <div class="af-form-group">
            <label class="" translate>lblAppointmentType</label>

            <div class="flexbox align-items-center">

                <div class="flexbox form-check pl-0">
                    <input type="radio" class="radio-custom m-0" id="quote" name="offertype" value="Quote"
                        disabled="true"
                        [(ngModel)]="commonService.editAppointmentService.appointmentDetails.appointmentType" />
                    <label translate class="text-dark ml-2" for="quote">
                        lblQuote
                    </label>
                </div>
                <div class="flexbox form-check ml-5">
                    <input type="radio" class="radio-custom m-0" id="order" name="offertype" disabled="true"
                        [(ngModel)]="commonService.editAppointmentService.appointmentDetails.appointmentType"
                        value="Order" />
                    <label translate class="text-dark ml-2" for="order">
                        lblOrder
                    </label>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 col-lg-6 col-xl-3">
        <div class="af-form-group">
            <label>
                <span translate>lblRegNumber</span>
            </label>
            <div class="lbl-info">
                <div class="flmid flex-wrap">
                    <div class="licplate LPNo d-flex">
                        <span class="icn-flag" [ngClass]="licensePlateClass"></span>
                        {{commonService.appointmentDetails.licensePlate}}
                    </div>
                    <div class="imgWid">
                        <ng-container>
                            <img af-brand-logo [data-code]="commonService.appointmentDetails.brandCode" data-type="BRAND"
                                class="{{commonService.appointmentDetails.brandCode}}-icon common"
                                [title]="commonService.appointmentDetails.brandCode" class="brandicon" alt="img" />
                        </ng-container>
                        <button class="btn btn-link ml-2" (click)="commonService.copyTextRegistrationNumber()"
                            placement="top" ngbTooltip="Copy Reg No." aria-label="Center Align">
                            <em class="fas fa-copy fa-lg"></em>
                        </button>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3" *ngIf="commonService.contactDetails">
        <div class="af-form-group">
            <label translate>lblBookedDate</label>
            <div class="lbl-info" *ngIf="commonService.appointmentBookedDate;else load_OwnerNotFound">
                {{commonService.appointmentBookedDate | date:'short'}}
            </div>
            <ng-template #load_OwnerNotFound>
                <span></span>
            </ng-template>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-2">
        <div class="af-form-group">
            <label translate>lblDocumentPartStatus</label>
            <div class="lbl-info"
                *ngIf="commonService.editAppointmentService.isEdit && !commonService.editAppointmentService.appointmentDetails.isFromArchive && isDocumentPartStatusActive;else load_OwnerNotFound">
                <ng-select [(ngModel)]="commonService.SelectedDocumentPartStatus"
                    [ngModelOptions]="{standalone: true}" [disabled]="StatusDisabled"
                    placeholder="{{ 'lblSelectStatus' | translate }}"
                    (change)="commonService.onDocumentPartStatusChange()" (clear)="resetDocumetStatus()">
                    <ng-option *ngFor="let status of commonService.documentPartStatus" [value]="status.code">
                        {{status.code}}
                    </ng-option>
                </ng-select>
            </div>
            <ng-template #load_OwnerNotFound>
                <span translate>-</span>
            </ng-template>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3">
        <div class="af-form-group">
            <label>
                <span translate>lblCustomer</span> / <span translate>lblOwner</span>
            </label>
            <div class="lbl-info">
                {{commonService.appointmentDetails.customerName}}
                <span
                    *ngIf="commonService.contactDetails && commonService.contactDetails.ownerName;else load_OwnerNotFound">
                    <span
                        *ngIf="commonService.appointmentDetails.customerName.toLowerCase() !== commonService.contactDetails.ownerName.toLowerCase()">
                        / {{commonService.contactDetails.ownerName}}
                    </span>
                </span>
                <ng-template #load_OwnerNotFound>
                    <span translate>/ -</span>
                </ng-template>
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3">
        <div class="af-form-group">
            <label translate>lblVinNumber</label>
            <div class="lbl-info">
                {{commonService.appointmentDetails.chassisNo}}
                <button class="btn btn-link ml-2" (click)="commonService.copyTextVINNumber()" placement="top"
                    ngbTooltip="Copy VIN No." aria-label="Center Align">
                    <em class="fas fa-copy fa-lg"></em>
                </button>
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3" *ngIf="commonService.contactDetails">
        <div class="af-form-group">
            <label>
                <span translate>lblAssignedMechanic</span>
            </label>
            <div class="lbl-info">
                <span class="lbl-info"
                    *ngIf="(commonService.contactDetails.plannedMechanics || commonService.contactDetails.pastPlannedMechanics) else elsePlannedMechanics">
                    <span class="text-muted">{{commonService.contactDetails.pastPlannedMechanics}}</span>
                    <span class="text-muted" *ngIf="commonService.contactDetails.pastPlannedMechanics && commonService.contactDetails.plannedMechanics">, </span>
                    <span class="font-weight-bold">{{commonService.contactDetails.plannedMechanics}}</span>
                </span>
                <ng-template #elsePlannedMechanics>
                    <span class="lbl-info" translate>lblNotYetAssigned</span>
                </ng-template>
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-2">
        <div class="af-form-group">
            <label translate>lblChangeStatus</label>
            <div class="lbl-info"
                *ngIf="commonService.editAppointmentService.isEdit && !commonService.editAppointmentService.appointmentDetails.isFromArchive;else load_OwnerNotFound">
                <ng-select [(ngModel)]="SelectedStatus" [ngModelOptions]="{standalone: true}"
                    [disabled]="StatusDisabled" placeholder="{{ 'lblSelectStatus' | translate }}"
                    (change)="onStatusChange()" (clear)="resetCalculations()">
                    <ng-option *ngFor="let status of commonService.statusList" [value]="status.id">
                        {{status.name}}
                    </ng-option>
                </ng-select>
                <ng-template #load_OwnerNotFound>
                    <span translate>-</span>
                </ng-template>
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-3" *ngIf="commonService.contactDetails">
        <div class="af-form-group" style="max-width: 65%;">
            <label translate>lblContactName</label>
            <div class="lbl-nfo">
                <input type="text" class="form-control"
                    [disabled]="!commonService.editAppointmentService.isEdit || commonService.editAppointmentService.appointmentDetails.isFromArchive"
                    [(ngModel)]="commonService.contactDetails.contactInfo" />
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3" *ngIf="commonService.contactDetails">
        <div class="af-form-group">
            <label translate>lblCampaignService</label>
            <div class="d-flex" style="flex-direction: column;">
                <div class="lbl-info d-flex">
                    <div style="width: 70%;">
                        <ng-select [(ngModel)]="commonService.contactDetails.campaignServiceId"
                            [ngModelOptions]="{standalone: true}"
                            [disabled]="!commonService.editAppointmentService.isEdit || commonService.editAppointmentService.appointmentDetails.isFromArchive"
                            placeholder="{{ 'lblSelectCampaign' | translate }}" (change)="onChangeCampaignService()">
                            <ng-option *ngFor="let campaign of serviceCampaignOptionList" [value]="campaign.id" translate>
                                {{campaign.campaignValue}}
                            </ng-option>
                        </ng-select>
                        <ng-template #load_OwnerNotFound>
                            <span translate>-</span>
                        </ng-template>
                    </div>
                    <div *ngIf="commonService.contactDetails?.campaignUpdatedBy || commonService.contactDetails?.campaignUpdateDate"
                        class="af-form-group mileage pl-2">
                        {{commonService.contactDetails.campaignUpdatedBy}} <br />
                        {{commonService.contactDetails.campaignUpdateDate}}
                    </div>
                </div>
                <div>
                    <div class="mt-2" style="width: 80%;">
                        <textarea *ngIf="commonService.contactDetails.campaignServiceId == 3"
                            [(ngModel)]="commonService.contactDetails.campaignServiceText"
                            [ngModelOptions]="{standalone: true}" class="form-control serviceCampaign" rows="2"
                            maxlength="150"
                            [ngClass]="{'border-red': commonService.contactDetails.campaignServiceId == 3 && isTextEmpty()}"></textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-3" *ngIf="commonService.contactDetails"
        [ngClass]="commonService.contactDetails && !commonService.contactDetails.isCustomerWaiting && !commonService.contactDetails?.isPickUpDropOffService ?  '' : 'disable'">
        <div class="af-form-group" style="max-width: 85%;">
            <label translate>lblCustomerDropTime</label>
            <div class="lbl-info">
                <ng-select #select [ngModelOptions]="{standalone: true}"
                    placeholder="{{ 'lblSelectCustomerDropTime' | translate }}"
                    (change)="onCustomerDropTimeSelected($event)"
                    [(ngModel)]="commonService.contactDetails.isKeyDrop"
                    [disabled]="!commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.editAppointmentService.appointmentDetails.isFromArchive">
                    <ng-option *ngFor="let item of CustomerDropTimeDropDownValues" [value]="item.value">
                        {{item.name | translate}}
                    </ng-option>
                </ng-select>
            </div>
            <ng-template #load_elseCustomerDropTime>
                <p translate class="lbl-info">-</p>
            </ng-template>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-2" *ngIf="commonService.contactDetails">
        <div class="af-form-group">
            <label translate>lblParkingNote</label>
            <div class="lbl-nfo">
                <input type="text" class="form-control"
                    [disabled]="!commonService.editAppointmentService.isEdit || commonService.editAppointmentService.appointmentDetails.isFromArchive"
                    [(ngModel)]="commonService.contactDetails.parkingNote" maxlength="200" />
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-3" *ngIf="commonService.contactDetails && mobileInitialized">
        <div class="af-form-group" style="max-width: 65%;">
            <label translate>lblContactMobile</label>
            <div class="lbl-nfo">
                <ngx-intl-tel-input [selectFirstCountry]= "false" (keypress)="commonService.isDigit($event)"
                [disabled]="!commonService.editAppointmentService.isEdit || commonService.editAppointmentService.appointmentDetails.isFromArchive"
                [(ngModel)]="contactMobileNo"
                [selectedCountryISO]="selectedContactCountryISO" [maxLength]="15" [phoneValidation]="false"
                [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="false"(countryChange)="onNomineeCountryChange($event)"
                (change)="mobileNumberChanged()">
                </ngx-intl-tel-input>
            </div>
        </div>
        <div class="af-form-group mt-2 mb-2" style="max-width:65%;">
            <label translate>lblSellToCustomerMobileNo</label>
            <div class="lbl-nfo">
                <ngx-intl-tel-input [selectFirstCountry]= "false" [(ngModel)]="sellToCustomerMobileNo"
                disabled [selectedCountryISO]="selectedSellCountryISO" [maxLength]="15" [phoneValidation]="false"
                [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="false"></ngx-intl-tel-input>
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3">
        <div class="af-form-group">
            <label translate>lblModel</label>
            <div class="lbl-info">
                {{commonService.appointmentDetails.modelName}}
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3">
        <div class="af-form-group">
            <label translate>lblDeliveryTime</label>
            <div class="lbl-info">
                <div class="d-flex align-items-center">
                    <div class="lbl-info date mr-3">
                        <input class="form-control datePicker width100force" appAfDatepicker
                            [ngModelOptions]="{standalone: true}" [dateTime]="false"
                            [(ngModel)]="commonService.DeliveryDate" [disableNextMonthDates]="true"
                            [defaultTime]="DefaultStartTime" [isOnlyTime]="false"
                            (ngModelChange)="onChangeDeliveryDate($event)"
                            [disabled]="!commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.editAppointmentService.appointmentDetails.isFromArchive">
                        <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                    </div>
                    <div class="date">
                        <ngb-timepicker [(ngModel)]="commonService.deliveryTimeSlot"
                            [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="onChangeDeliveryTime($event)"></ngb-timepicker>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-2" style="display: flex; flex-direction: column;">
        <div>
            <label>Check In Status</label>
            <ng-container>
                <div
                    *ngIf="commonService.contactDetails?.isCheckInDoneByCustomer === true  && commonService.contactDetails.workorderStatusId !=12">
                    <em class="fas fa-check fa-lg"></em>
                    <label class="form-check-label" style="margin-top:5px" translate>lblCheckInCompleted</label>
                </div>
                <div *ngIf="commonService.contactDetails?.isCheckInDoneByCustomer === false">
                    <em class="fas fa-times text-danger fa-lg cursordisable"></em>
                    <label class="form-check-label" style="margin-top:5px" translate>lblCheckInCompleted</label>
                </div>
                <div class="d-flex">
                    <div *ngIf="commonService.isShowGenerateAndSendCheckInButton">
                        <button class="btn btn-link  btn-lg" (click)="generateAndSendCheckinLink()" placement="top"
                            ngbTooltip="{{ 'lblGenerateAndSMSCheckInLink' | translate }}" aria-label="Center Align">
                            <em class="icon-tracker-mail font26"></em>
                        </button>
                    </div>
                    <span class="ico-div"></span>
                    <div *ngIf="commonService.isShowGenerateTrackerButton" class="ml-2">
                        <button class="btn btn-link  btn-lg" (click)="generateTrackerLink()" placement="top"
                            ngbTooltip="{{ 'lblGenerateTrackerLink' | translate }}" aria-label="Center Align">
                            <em class="icon-tracker font26"></em>
                        </button>
                
                        <button class="btn btn-link ml-2 btn-lg" (click)="generateAndSendTrackerLink()" placement="top"
                            ngbTooltip="{{ 'lblGenerateAndSMSTrackerLink' | translate }}" aria-label="Center Align">
                            <em class="icon-tracker-mail font26"></em>
                        </button>
                    </div>
                </div>
            </ng-container>
        </div>
        <div style="margin-top: 10px; margin-bottom: 10px;" *ngIf="isShareBoxEnabled && (editAppointmentService.appointmentDetails.isKeyDrop || editAppointmentService.appointmentDetails.isAutoKey)">
            <label translate>lblShareboxStatus</label> <span *ngIf="editAppointmentService.appointmentDetails.sentShareboxInfo"><img src="../../../../../../assets/images/sharebox0.png" width="25" style="margin-left: 1rem; margin-bottom: 2px;"/></span>
            <ng-container>
                <div *ngIf="editAppointmentService.appointmentDetails.sentShareboxInfo && (editAppointmentService.appointmentDetails.isKeyDrop || editAppointmentService.appointmentDetails.isAutoKey)">
                    <em class="fas fa-check fa-lg"></em>
                    <label class="form-check-label" style="margin-top:5px" translate>lblShareBoxInformationShared</label>
                </div>
                <div
                    *ngIf="!editAppointmentService.appointmentDetails.sentShareboxInfo && (editAppointmentService.appointmentDetails.isKeyDrop || editAppointmentService.appointmentDetails.isAutoKey)">
                    <em class="fas fa-times text-danger fa-lg cursordisable"></em>
                    <label class="form-check-label" style="margin-top:5px" translate>lblShareboxInfoNotSent</label>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3 mt-2 mb-2" *ngIf="commonService.contactDetails">
            <div class="af-form-group">
                <label>
                    <span translate>lblServiceAdvisors</span>
                </label>
                <div class="d-flex" style="flex-direction: column;">
                    <div class="lbl-info d-flex align-items-center">
                        <div style="width: 70%;">
                            <ng-select [(ngModel)]="commonService.contactDetails.serviceAdvisorId"
                                [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="onServiceAdvisorChange($event)"
                                [clearable]="!!commonService.contactDetails.serviceAdvisorId"
                                [disabled]="!commonService.editAppointmentService.isEdit || commonService.editAppointmentService.appointmentDetails.isFromArchive"
                                placeholder="{{ 'lblSelectServiceAdvisor' | translate }}">
                                <ng-option *ngFor="let serviceAdvisor of commonService.serviceAdvisorList" [value]="serviceAdvisor.userId" translate>
                                    {{serviceAdvisor.userName}}
                                </ng-option>
                            </ng-select>
                            <ng-template #load_OwnerNotFound>
                                <span translate>-</span>
                            </ng-template>
                        </div>
                        <div class="form-check pl-0 ml-2">
                            <input type="checkbox" placeholder="{{ 'lblAuthorizedByServiceAdvisor' | translate }}"
                                [(ngModel)]="commonService.contactDetails.isAuthorizedByServiceAdvisor"
                                [ngModelOptions]="{standalone: true}"
                                (change)="onServiceAdvisorAuthorizationChange($event)"
                                [disabled]="!commonService.editAppointmentService.isEdit || commonService.editAppointmentService.appointmentDetails.isFromArchive || !(commonService.serviceAdvisorList?.length > 0)" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    <div class="col-6 col-lg-6 col-xl-3" *ngIf="commonService.contactDetails">
        <div class="af-form-group">
            <label translate>lbl1stRegistrationDate</label>
            <div class="lbl-info">
                {{commonService.contactDetails.registrationDate}}
            </div>
        </div>
    </div>

    <div class="col-6 col-lg-3" *ngIf="commonService.contactDetails"
        [ngClass]="commonService.contactDetails && !commonService.contactDetails.isCustomerWaiting  && !commonService.contactDetails?.isPickUpDropOffService ?  '' : 'disable'">
        <div class="af-form-group" style="max-width: 85%;">
            <label translate>lblCustomerPickUpTime</label>
            <div class="lbl-info">
                <ng-select #select [ngModelOptions]="{standalone: true}"
                    placeholder="{{ 'lblSelectCustomerPickUpTime' | translate }}"
                    (change)="onCustomerPickUpTimeSelected($event)"
                    [(ngModel)]="commonService.contactDetails.isAutoKey"
                    [disabled]="!commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.editAppointmentService.appointmentDetails.isFromArchive">
                    <ng-option *ngFor="let item of CustomerPickUpTimeDropDownValues" [value]="item.value">
                        {{item.name | translate}}
                    </ng-option>
                </ng-select>
            </div>
            <ng-template #load_elseCustomerPickUpTime>
                <p translate class="lbl-info">-</p>
            </ng-template>
        </div>
    </div>

    <div class="col-6 col-lg-6 col-xl-3" *ngIf="commonService.contactDetails">
        <div *ngIf="isNeedAttention">
            <label translate>lblNeedAttention</label>
            <ng-container>
                <div>
                    <em class="fa fa-exclamation-triangle text-warning fa-lg"
                        *ngIf="commonService.contactDetails.needAttention === 1"></em>
                    <em class="fas fa-times text-danger fa-lg cursordisable"
                        *ngIf="commonService.contactDetails.needAttention === 0"></em>
                    <label class="form-check-label"
                        *ngIf="commonService.contactDetails.needAttention === 0 || commonService.contactDetails.needAttention === 1"
                        translate>lblNeedAttention</label>
                    <em class="fas fa-check fa-lg" *ngIf="commonService.contactDetails.needAttention === 2">
                        <label class="form-check-label" translate>lblResolved</label>
                    </em>
                    <button class="btn btn-primary mr-sm-2 ml-3 btn-sm" *ngIf="commonService.contactDetails.needAttention === 1"
                        (click)="UpdateNeedAttention()" translate aria-label="Center Align"
                        [disabled]="!commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.editAppointmentService.appointmentDetails.isFromArchive">lblResolve
                    </button>
                </div>
            </ng-container>

            <ng-container *ngIf="commonService.IsonHoldStatus">
                <div>
                    <em class="fas fa-check fa-lg" *ngIf="commonService.contactDetails.isCarRemainInWorkshop"></em>
                    <em class="fas fa-times text-danger fa-lg"
                        *ngIf="commonService.contactDetails.isCarRemainInWorkshop === false"></em>
                    <label class="form-check-label" style="margin-top:5px" translate>lblCarWillRemainInWorkshop</label>
                </div>
            </ng-container>
        </div>
        <div *ngIf="!isNeedAttention" [ngClass]="commonService.contactDetails.isPickUpDropOffService ?  'disable' : '' ">
            <div class="d-flex">
                <div class="af-form-group">
                    <label translate>lblTransportation</label>
                    <div class="lbl-info d-flex mb-2" *ngIf="isTransportAvailable('1')">
                        <input type="radio" id="wishTransportTicket"
                            [checked]="this.commonService.appointmentDetails.noNeedTransport"
                            (change)="onChangeTransportSolution(1)"
                            [disabled]="!commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.contactDetails.isCustomerWaiting || commonService.editAppointmentService.appointmentDetails.isFromArchive">
                        <label translate class="ml-2">
                            lblWishNoTransport
                        </label>
                    </div>
                    <div class="lbl-info d-flex mb-2" *ngIf="isTransportAvailable('2')">
                        <input type="radio" id="wishTransportTicket"
                            [checked]="this.commonService.appointmentDetails.needTransportTicket"
                            (change)="onChangeTransportSolution(2)"
                            [disabled]="!commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.contactDetails.isCustomerWaiting || commonService.editAppointmentService.appointmentDetails.isFromArchive">
                        <label translate class="ml-2">
                            lblWishTransportTicket
                        </label>
                    </div>
                    <div class="form-check pl-0 d-flex mb-2" *ngIf="isTransportAvailable('3')">
                        <ng-container *ngIf="commonService.isRentalService">
                            <input type="radio" id="rentalCar" [checked]="commonService.contactDetails.isRentalCarSelected"
                                (change)="onChangeTransportSolution(3)"
                                [disabled]="!commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.contactDetails.isCustomerWaiting || commonService.editAppointmentService.appointmentDetails.isFromArchive" />
                        </ng-container>
                        <ng-container
                            *ngIf="(commonService.contactDetails.rentalVehicleId && commonService.contactDetails.rentalVehicleId!=='0' )|| commonService.isRentalService">
                            <label class="form-check-label" translate>lblAvailRentalCar</label>
                            <div class="ml-2"
                                *ngIf="((commonService.contactDetails.rentalVehicleId && (commonService.contactDetails.rentalVehicleId!=='0')) || commonService.isRentalService ) && commonService.contactDetails.rentalVehicleId !== '-1' &&  commonService.contactDetails.rentalVehicleId!==null && commonService.contactDetails.isRentalCarSelected">
                                <span
                                    *ngIf="((commonService.contactDetails.rentalVehicleId && commonService.contactDetails.rentalVehicleId!=='0') || commonService.isRentalService);else load_elseVehicle">
                                    {{ commonService.contactDetails.rentalCompanyMakeName }} -
                                    <span *ngIf="!commonService.genericRentalCar">
                                        {{ commonService.contactDetails.price | number:'1.2-2' }}
                                    </span>
                                    <span *ngIf="commonService.genericRentalCar">
                                        {{ commonService.contactDetails.priceForDisply }}
                                    </span>
                                </span>
                                <ng-template #load_elseVehicle>
                                    -
                                </ng-template>
                            </div>
                        </ng-container>
                    </div>
                    <div class="lbl-info">
                        <div
                            *ngIf="(commonService.contactDetails.typeId > 0 || commonService.isRentalService || commonService.isRentalService) && commonService.contactDetails.rentalVehicleId === '-1' && commonService.contactDetails.isRentalCarSelected">
                            {{ commonService.contactDetails.type }} -
                            {{ commonService.contactDetails.rentalPrice }}
                        </div>
                        <div
                            *ngIf="(commonService.contactDetails.typeId > 0 || commonService.contactDetails.type?.length > 0) && commonService.contactDetails.isRentalCarSelected && commonService.contactDetails.rentalVehicleId === null">
                            {{ commonService.contactDetails.type }} -
                            {{ commonService.contactDetails.rentalPrice }}
                        </div>
                        <ng-container
                            *ngIf="isTransportAvailable('3') && !this.commonService.appointmentDetails.noNeedTransport && !this.commonService.appointmentDetails.needTransportTicket && (commonService.isRentalService || commonService.genericRentalCar)">
                            <button type="submit"
                                [disabled]="!commonService.contactDetails.isRentalCarSelected || !commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.contactDetails.isCustomerWaiting || commonService.editAppointmentService.appointmentDetails.isFromArchive"
                                (click)="OpenRentalCarListPopup(SelectRentalCarContent)" class="btn btn-primary mr-sm-2" translate
                                aria-label="Center Align">lblSelectCar</button>
                        </ng-container>
                    </div>
                    <ng-template #SelectRentalCarContent let-modal>
                        <div class="modal-header">
                            <h2 class="modal-title" translate>lblSelectRentalCar</h2>
                            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss(false)">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div class="modal-body p-0 ">
                            <div class="popup-vcenter ">
                                <div class="flgrow">
                                    <ng-container>
                                        <div class="">
                                            <div class=" table-responsive">
                                                <table class="tablest1" *ngIf="!commonService.genericRentalCar">
                                                    <thead>
                                                        <tr>
                                                            <th id="Brand" scope="col" translate>lblBrand</th>
                                                            <th id="LicencePlate" scope="col" translate>lblRegNumber</th>
                                                            <th id="Model" scope="col" translate>lblModel</th>
                                                            <th id="Price" scope="col" translate>lblPrice</th>
                                                            <th id="Actions" scope="col" style="width:75px" class="text-center"
                                                                translate>
                                                                lblAction</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <ng-container
                                                            *ngIf="commonService.availRentalCarList?.length > 0; else load_NotFound_Search">
                                                            <tr *ngFor="let car of commonService.availRentalCarList; let i=index">
                                                                <td>
                                                                    {{car.makeName}}
                                                                </td>
                                                                <td>
                                                                    {{car.licensePlate}}
                                                                </td>
                                                                <td>
                                                                    {{car.model}}
                                                                </td>
                                                                <td>
                                                                    {{car.price}}
                                                                </td>
                                                                <td class="text-center" style="width:100px">
                                                                    <input name="Search" type="radio"
                                                                        [(ngModel)]="selectedRentalCarId" [value]="car.vehicleId" />
                                                                </td>
                                                            </tr>
                                                        </ng-container>
                                                        <ng-template #load_NotFound_Search>
                                                            <tr>
                                                                <td colspan="8" class="no-record" translate>
                                                                    lblNoRecordsFound</td>
                                                            </tr>
                                                        </ng-template>
                                                    </tbody>
                                                </table>
                                                <table class="tablest1" *ngIf="commonService.genericRentalCar">
                                                    <thead>
                                                        <tr>
                                                            <th id="brand" translate>lblType</th>
                                                            <th id="price" translate>lblPrice</th>
                                                            <th id="Actions" scope="col" style="width:75px" class="text-center"
                                                                translate>
                                                                lblAction</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <ng-container
                                                            *ngIf="commonService.genericRentalCarList?.length>0; else load_NotFound_Search">
                                                            <tr *ngFor="let car of commonService.genericRentalCarList; let i=index">
                                                                <td>
                                                                    {{car.type}}
                                                                </td>
                                                                <td>
                                                                    {{car.price}}
                                                                </td>
                                                                <td class="text-center" style="width:100px">
                                                                    <input name="Search" type="radio"
                                                                        [(ngModel)]="selectedGenericRentalCarId"
                                                                        [value]="car.typeId" />
                                                                </td>
                                                            </tr>
                                                        </ng-container>
                                                        <ng-template #load_NotFound_Search>
                                                            <tr>
                                                                <td colspan="3" class="no-record" translate>
                                                                    lblNoRecordsFound</td>
                                                            </tr>
                                                        </ng-template>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
            
                        <div class="modal-footer">
                            <button type="submit" [disabled]="!selectedRentalCarId && !selectedGenericRentalCarId"
                                class="btn btn-primary mr-sm-2" (click)="onRentalCarSelected();modal.dismiss(false)" translate
                                aria-label="Center Align">lblSelect</button>
                            <button (click)="modal.dismiss(false)" class="btn btn-secondary" aria-label="Center Align"
                                translate>lblCancel</button>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-3" *ngIf="commonService.contactDetails">
        <div class="af-form-group" style="max-width: 65%;">
            <label translate>lblInformation</label>
            <div class="lbl-nfo">
                <input type="text" class="form-control" maxlength="70"
                    [disabled]="!commonService.editAppointmentService.isEdit || commonService.editAppointmentService.appointmentDetails.isFromArchive"
                    [(ngModel)]="commonService.contactDetails.information" />
            </div>
        </div>
    </div>

    <div class="col-6 col-lg-6 col-xl-3" *ngIf="commonService.contactDetails">
        <div class="af-form-group">
            <label translate>lblMileage</label>
            <div class="lbl-info">
                <div class="d-flex align-items-center">
                    <div class="lbl-info relative km-block">
                        <input type="text" class="form-control kminput text-right"
                            [value]="commonService.contactDetails.kilometer"
                            [disabled]="!commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.editAppointmentService.appointmentDetails.isFromArchive"
                            [(ngModel)]="commonService.contactDetails.kilometer" min="0" required maxlength="9"
                            [ngClass]="(+commonService.contactDetails.kilometer) === (+commonService.contactDetails.previousKilometer) ? 'bg-danger' : '' " />
                        <span class="mil-km">KM</span>
                    </div>
                    <div *ngIf ="commonService.contactDetails?.mileageUpdateBy || commonService.contactDetails?.mileageUpdateDate" class="af-form-group mileage pl-2">
                        {{commonService.contactDetails.mileageUpdateBy}} <br/>
                        {{commonService.contactDetails.mileageUpdateDate}}
                </div>
                </div>
            </div>
        </div>
    </div>

        <div class="col-6 col-lg-6 col-xl-3">
            <div class="af-form-group">
                <label translate>lblFinishedTime</label>
                <div class="lbl-info">
                    <div class="d-flex align-items-center">
                        <div class="lbl-info date mr-3">
                            <input class="form-control datePicker width100force" appAfDatepicker
                                [ngModelOptions]="{standalone: true}" [dateTime]="false"
                                [(ngModel)]="commonService.FinnishedDate" [disableNextMonthDates]="true"
                                [defaultTime]="DefaultEndTime" [isOnlyTime]="false"
                                (ngModelChange)="onChangeFinnishedDate($event)"
                                [disabled]="!commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.editAppointmentService.appointmentDetails.isFromArchive || commonService.DeliveryHour > 23 || commonService.DeliveryMinutes >=60">
                            <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                        </div>
                        <div class="date">
                            <ngb-timepicker [(ngModel)]="commonService.finishTimeSlot"
                                [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="onChangeFinnishedTime($event)"></ngb-timepicker>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-6 col-lg-6 col-xl-3" *ngIf="commonService.contactDetails && !isNeedAttention">
            <div class="af-form-group" style="max-width: 65%;">
                <label translate>lblInvoiceReference</label>
                <div class="lbl-nfo">
                    <input type="text" class="form-control" maxlength="35"
                        [disabled]="!commonService.editAppointmentService.isEdit || commonService.editAppointmentService.appointmentDetails.isFromArchive"
                        [(ngModel)]="commonService.contactDetails.invoiceReference" />
                </div>
            </div>
        </div>

    <div class="col-6 col-lg-6 col-xl-3" [hidden]="true">
        <div class="af-form-group">
            <label>
                <span translate>lblSalesPerson</span>
            </label>
            <div class="lbl-info">
                <ng-select [(ngModel)]="commonService.SelectedSalesPerson" [ngModelOptions]="{standalone: true}"
                    [disabled]="StatusDisabled" placeholder="{{ 'lblSelectSalesPerson' | translate }}"
                    (change)="commonService.onSalesPersonChange()" (clear)="commonService.resetSalesPersonList()">
                    <ng-option *ngFor="let item of salesPersonList" [value]="item.id">
                        [{{item.code}}] {{item.name}}
                    </ng-option>
                </ng-select>
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3" *ngIf="commonService.contactDetails">
        <div class="col-lg-12 row" style="display: flex;">
            <div class="form-check pl-0 mr-4 mb-3">
                <input type="checkbox" id="isImportedCar" [(ngModel)]="commonService.contactDetails.importedCar"
                    (ngModelChange)="onChangeImportedCar($event)"
                    [disabled]="!commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.editAppointmentService.appointmentDetails.isFromArchive" />
                <label class="form-check-label" translate>lblImportedCar</label>
            </div>
            <div class="form-check pl-0 mr-4 mb-3">
                <input type="checkbox" id="isToweinCars" [(ngModel)]="commonService.contactDetails.toweinCars"
                    (ngModelChange)="onChangeToweinCar($event)"
                    [disabled]="!commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.editAppointmentService.appointmentDetails.isFromArchive" />
                <label class="form-check-label" translate>lblToweinCars</label>
            </div>
            <div class="form-check pl-0 mr-2 mb-3" *ngIf="isTireHotelActive">
                <input type="checkbox" id="isTireHotel" [(ngModel)]="commonService.contactDetails.isTireHotel"
                    (ngModelChange)="onChangeTireHotel($event)"
                    [disabled]="!commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.editAppointmentService.appointmentDetails.isFromArchive" />
                <label class="form-check-label" translate>lblTireHotel</label>
            </div>
            </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3" *ngIf="commonService.contactDetails">
        <div class="af-form-group">
            <label>
                <span translate>lblEUControl</span>
            </label>
            <div class="lbl-info" *ngIf="commonService.appointmentPKKDate else EUDate">
                <span [ngClass]="DateClass">{{ commonService.appointmentPKKDate }}</span>
            </div>
            <ng-template class="lbl-info" #EUDate>
                -
            </ng-template>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3" *ngIf="commonService.contactDetails && isNeedAttention">
        <div class="d-flex">
            <div class="af-form-group">
                <label translate>lblTransportation</label>
                <div class="lbl-info d-flex mb-2">
                    <input type="radio" id="wishTransportTicket"
                        [checked]="this.commonService.appointmentDetails.noNeedTransport"
                        (change)="onChangeTransportSolution(1)"
                        [disabled]="!commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.contactDetails.isCustomerWaiting || commonService.editAppointmentService.appointmentDetails.isFromArchive">
                    <label translate class="ml-2">
                        lblWishNoTransport
                    </label>
                </div>
                <div class="lbl-info d-flex mb-2">
                    <input type="radio" id="wishTransportTicket"
                        [checked]="this.commonService.appointmentDetails.needTransportTicket"
                        (change)="onChangeTransportSolution(2)"
                        [disabled]="!commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.contactDetails.isCustomerWaiting || commonService.editAppointmentService.appointmentDetails.isFromArchive">
                    <label translate class="ml-2">
                        lblWishTransportTicket
                    </label>
                </div>
                <div class="form-check pl-0 d-flex mb-2">
                    <ng-container *ngIf="commonService.isRentalService">
                        <input type="radio" id="rentalCar" [checked]="commonService.contactDetails.isRentalCarSelected"
                            (change)="onChangeTransportSolution(3)"
                            [disabled]="!commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.contactDetails.isCustomerWaiting || commonService.editAppointmentService.appointmentDetails.isFromArchive" />
                    </ng-container>
                    <ng-container
                        *ngIf="(commonService.contactDetails.rentalVehicleId && commonService.contactDetails.rentalVehicleId!=='0' )|| commonService.isRentalService">
                        <label class="form-check-label" translate>lblAvailRentalCar</label>
                        <div class="ml-2"
                            *ngIf="((commonService.contactDetails.rentalVehicleId && (commonService.contactDetails.rentalVehicleId!=='0')) || commonService.isRentalService ) && commonService.contactDetails.rentalVehicleId !== '-1' &&  commonService.contactDetails.rentalVehicleId!==null && commonService.contactDetails.isRentalCarSelected">
                            <span
                                *ngIf="((commonService.contactDetails.rentalVehicleId && commonService.contactDetails.rentalVehicleId!=='0') || commonService.isRentalService);else load_elseVehicle">
                                {{ commonService.contactDetails.rentalCompanyMakeName }} -
                                <span *ngIf="!commonService.genericRentalCar">
                                    {{ commonService.contactDetails.price | number:'1.2-2' }}
                                </span>
                                <span *ngIf="commonService.genericRentalCar">
                                    {{ commonService.contactDetails.priceForDisply }}
                                </span>
                            </span>
                            <ng-template #load_elseVehicle>
                                -
                            </ng-template>
                        </div>
                    </ng-container>
                </div>
                <div class="lbl-info">
                    <div
                        *ngIf="(commonService.contactDetails.typeId > 0 || commonService.isRentalService || commonService.isRentalService) && commonService.contactDetails.rentalVehicleId === '-1' && commonService.contactDetails.isRentalCarSelected">
                        {{ commonService.contactDetails.type }} -
                        {{ commonService.contactDetails.rentalPrice }}
                    </div>
                    <div
                        *ngIf="(commonService.contactDetails.typeId > 0 || commonService.contactDetails.type?.length > 0) && commonService.contactDetails.isRentalCarSelected && commonService.contactDetails.rentalVehicleId === null">
                        {{ commonService.contactDetails.type }} -
                        {{ commonService.contactDetails.rentalPrice }}
                    </div>
                    <ng-container
                        *ngIf="!this.commonService.appointmentDetails.noNeedTransport && !this.commonService.appointmentDetails.needTransportTicket && (commonService.isRentalService || commonService.genericRentalCar)">
                        <button type="submit"
                            [disabled]="!commonService.contactDetails.isRentalCarSelected || !commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.contactDetails.isCustomerWaiting || commonService.editAppointmentService.appointmentDetails.isFromArchive"
                            (click)="OpenRentalCarListPopup(SelectRentalCarContent)" class="btn btn-primary mr-sm-2"
                            translate aria-label="Center Align">lblSelectCar</button>
                    </ng-container>
                </div>
                <ng-template #SelectRentalCarContent let-modal>
                    <div class="modal-header">
                        <h2 class="modal-title" translate>lblSelectRentalCar</h2>
                        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss(false)">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body p-0 ">
                        <div class="popup-vcenter ">
                            <div class="flgrow">
                                <ng-container>
                                    <div class="">
                                        <div class=" table-responsive">
                                            <table class="tablest1" *ngIf="!commonService.genericRentalCar">
                                                <thead>
                                                    <tr>
                                                        <th id="Brand" scope="col" translate>lblBrand</th>
                                                        <th id="LicencePlate" scope="col" translate>lblRegNumber</th>
                                                        <th id="Model" scope="col" translate>lblModel</th>
                                                        <th id="Price" scope="col" translate>lblPrice</th>
                                                        <th id="Actions" scope="col" style="width:75px" class="text-center"
                                                            translate>
                                                            lblAction</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <ng-container
                                                        *ngIf="commonService.availRentalCarList?.length > 0; else load_NotFound_Search">
                                                        <tr
                                                            *ngFor="let car of commonService.availRentalCarList; let i=index">
                                                            <td>
                                                                {{car.makeName}}
                                                            </td>
                                                            <td>
                                                                {{car.licensePlate}}
                                                            </td>
                                                            <td>
                                                                {{car.model}}
                                                            </td>
                                                            <td>
                                                                {{car.price}}
                                                            </td>
                                                            <td class="text-center" style="width:100px">
                                                                <input name="Search" type="radio"
                                                                    [(ngModel)]="selectedRentalCarId"
                                                                    [value]="car.vehicleId" />
                                                            </td>
                                                        </tr>
                                                    </ng-container>
                                                    <ng-template #load_NotFound_Search>
                                                        <tr>
                                                            <td colspan="8" class="no-record" translate>
                                                                lblNoRecordsFound</td>
                                                        </tr>
                                                    </ng-template>
                                                </tbody>
                                            </table>
                                            <table class="tablest1" *ngIf="commonService.genericRentalCar">
                                                <thead>
                                                    <tr>
                                                        <th id="brand" translate>lblType</th>
                                                        <th id="price" translate>lblPrice</th>
                                                        <th id="Actions" scope="col" style="width:75px" class="text-center"
                                                            translate>
                                                            lblAction</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <ng-container
                                                        *ngIf="commonService.genericRentalCarList?.length>0; else load_NotFound_Search">
                                                        <tr
                                                            *ngFor="let car of commonService.genericRentalCarList; let i=index">
                                                            <td>
                                                                {{car.type}}
                                                            </td>
                                                            <td>
                                                                {{car.price}}
                                                            </td>
                                                            <td class="text-center" style="width:100px">
                                                                <input name="Search" type="radio"
                                                                    [(ngModel)]="selectedGenericRentalCarId"
                                                                    [value]="car.typeId" />
                                                            </td>
                                                        </tr>
                                                    </ng-container>
                                                    <ng-template #load_NotFound_Search>
                                                        <tr>
                                                            <td colspan="3" class="no-record" translate>
                                                                lblNoRecordsFound</td>
                                                        </tr>
                                                    </ng-template>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
    
                    <div class="modal-footer">
                        <button type="submit" [disabled]="!selectedRentalCarId && !selectedGenericRentalCarId"
                            class="btn btn-primary mr-sm-2" (click)="onRentalCarSelected();modal.dismiss(false)" translate
                            aria-label="Center Align">lblSelect</button>
                        <button (click)="modal.dismiss(false)" class="btn btn-secondary" aria-label="Center Align"
                            translate>lblCancel</button>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3" *ngIf="commonService.contactDetails">
        <div class="form-check pl-0">
            <input type="checkbox" id="isCustomerWaiting" [(ngModel)]="commonService.contactDetails.isCustomerWaiting"
                (ngModelChange)="onSelectCustomerWaitingCheckBox()"
                [disabled]="!commonService.editAppointmentService.isEdit || isWorkOrderHistory || commonService.editAppointmentService.appointmentDetails.isFromArchive" />
            <label class="form-check-label" translate>lblCustomerWaiting</label>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3 mb-4" *ngIf="commonService.contactDetails && isDiscountCodeActive">
        <div class="af-form-group" style="max-width: 65%;">
            <label translate>lblDiscountCode</label>
            <div class="lbl-nfo">
                <input type="text" class="form-control" maxlength="30"
                    [disabled]="!commonService.editAppointmentService.isEdit || commonService.editAppointmentService.appointmentDetails.isFromArchive"
                    [(ngModel)]="commonService.contactDetails.discountCode"
                    (keypress)="$event.key === ' ' ? $event.preventDefault() : null"/>
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3">
        <div class="af-form-group">
            <div class="d-flex align-items-center">
                <label translate>lblInternalCommnets</label>
                <a class="btn btn-ico ml-1" (click)="open(Internalcontent)">
                    <em class="fas fa-comment-alt fa-lg"></em>
                </a>
                <a class="btn btn-ico" (click)="ViewComment(viewComment,1)">
                    <em class="fas fa-eye fa-lg"></em>
                    <span class="position-absolute translate-middle badge rounded-pill count" *ngIf="commonService.internalComments?.length > 0"
                        style="margin-top: 2px !important; background-color: #ED5153; color: #ffff;">
                        {{commonService.internalComments?.length}} </span>
                </a>
            </div>
            <div *ngIf="commonService.internalComments.length > 0">
                <div class="lbl-info" onfocus=""
                (mouseover)="isHoveredInternalComment = true" 
                (mouseleave)="isHoveredInternalComment = false">
                    <span *ngIf="!isHoveredInternalComment" (click)="ViewComment(viewComment, 1)">
                        {{ getTruncatedComment(commonService.internalComments[(commonService.internalComments.length - 1)]?.comment) }}
                    </span>
                    
                    <span *ngIf="isHoveredInternalComment" (click)="ViewComment(viewComment, 1)">
                    {{ commonService.internalComments[(commonService.internalComments.length - 1)]?.comment }}
                    </span>
                    <a class="btn btn-ico ml-2" (click)="copyInternalComments()">
                        <em class="fas fa-copy fa-lg"></em>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3">
        <div class="af-form-group">
            <div class="d-flex align-items-center">
                <label translate>lblCustomerCommets</label>
                <a class="btn btn-ico" (click)="ViewComment(viewComment,3)">
                    <em class="fas fa-eye fa-lg"></em>
                    <span class="position-absolute translate-middle badge rounded-pill count" *ngIf="commonService.customerComments?.length > 0"
                        style="margin-top: 2px !important; background-color: #ED5153; color: #ffff;">
                        {{commonService.customerComments?.length}}</span>
                </a>
            </div>
            <div *ngIf="commonService.customerComments.length > 0">
                <div class="lbl-info" onfocus=""
                (mouseover)="isHoveredCustomerComment = true" 
                (mouseleave)="isHoveredCustomerComment = false">
                <span *ngIf="!isHoveredCustomerComment" (click)="ViewComment(viewComment, 3)">
                    {{ getTruncatedComment(commonService.customerComments[(commonService.customerComments.length - 1)]?.comment) }}
                </span>
                
                <span *ngIf="isHoveredCustomerComment" (click)="ViewComment(viewComment, 3)">
                {{ commonService.customerComments[(commonService.customerComments.length - 1)]?.comment }}
                </span>
                    <a class="btn btn-ico ml-2" (click)="copyCustomerComments()">
                        <em class="fas fa-copy fa-lg"></em>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3" *ngIf="isDsoActive">
        <div class="af-form-group">
            <div class="d-flex align-items-center">
                <label translate>lblMechanicComments</label>
                <a class="btn btn-ico" (click)="ViewComment(viewComment,2)">
                    <em class="fas fa-eye fa-lg"></em>
                    <span class="position-absolute translate-middle badge rounded-pill count" *ngIf="commonService.mechanicComments?.length > 0"
                        style="margin-top: 2px !important; background-color: #ED5153; color: #ffff;">
                        {{commonService.mechanicComments?.length}} </span>
                </a>
            </div>
            <div *ngIf="commonService.mechanicComments.length > 0">
                <div class="lbl-info" onfocus="" (mouseover)="isHoveredMechanicComment = true"
                    (mouseleave)="isHoveredMechanicComment = false">
                    <span *ngIf="!isHoveredMechanicComment" (click)="ViewComment(viewComment, 2)">
                        {{ getTruncatedComment(commonService.mechanicComments[(commonService.mechanicComments.length -
                        1)]?.comment) }}
                    </span>
    
                    <span *ngIf="isHoveredMechanicComment" (click)="ViewComment(viewComment, 2)">
                        {{ commonService.mechanicComments[(commonService.mechanicComments.length - 1)]?.comment }}
                    </span>
                    <a class="btn btn-ico ml-2" (click)="copyMechanicComments()">
                        <em class="fas fa-copy fa-lg"></em>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-6 col-xl-3" *ngIf="commonService.contactDetails && isNeedAttention">
        <div class="af-form-group" style="max-width: 65%;">
            <label translate>lblInvoiceReference</label>
            <div class="lbl-nfo">
                <input type="text" class="form-control" maxlength="35"
                    [disabled]="!commonService.editAppointmentService.isEdit || commonService.editAppointmentService.appointmentDetails.isFromArchive"
                    [(ngModel)]="commonService.contactDetails.invoiceReference" />
            </div>
        </div>
    </div>
</div>
<ng-template #Internalcontent let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>lblInternalCommnets</h4>
        <button type="button" class="close" #closeModal id="modelButton" aria-label="Close"
            (click)="modal.dismiss('Cross click')"><span aria-hidden="true">×</span></button>
    </div>
    <div class="modal-body">
        <form>
            <div class="mb-3">
                <div class="af-form-group">
                    <label translate>lblComment</label>
                    <textarea name="" class="form-control" rows="5" [(ngModel)]="commonService.internalCommentData"
                        [ngModelOptions]="{standalone: true}"></textarea>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="submit" class="btn btn-primary btn-lg"
            [disabled]="!editAppointmentService.isEdit || commonService.internalCommentData == null"
            (click)="AddInternalComment()" translate>lblSave</button>
        <button type="button" class="btn btn-secondary btn-lg" (click)="modal.close('Cancel click')"
            translate>lblCancel</button>
    </div>
</ng-template>
<ng-template #editContent let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>lblEditInternalCommnets
        </h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')"><span
                aria-hidden="true">×</span></button>
    </div>
    <div class="modal-body table-responsive">
        <form [formGroup]="editcommentform">
            <label class="text" for="comment" translate>
                lblComment <strong class="mlt6 required"> * </strong>
            </label>
            <div class="lbl-info">
                <input formControlName="comment" class="form-control mb-2" [(ngModel)]="editCommentText">
            </div>
            <div *ngIf="!editcommentform.controls.comment?.valid && (editcommentform.controls.comment?.dirty || editcommentform.controls.comment?.touched)"
                class="help-block text-danger">
                <span translate>lblCommentRequired</span>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-lg" (click)="EditCommentDetails()"
            [disabled]="!editcommentform.valid" translate><em
                class="far fa-save font16 align-top mr-2"></em>lblSave</button>
        <button type="button" class="btn btn-secondary btn-lg" (click)="modal.close('Cancel click')"
            translate><em class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</button>
    </div>
</ng-template>
<ng-template #viewComment let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" *ngIf="commentType===1" translate>lblInternalCommnets
        </h4>
        <h4 class="modal-title" id="modal-basic-title" *ngIf="commentType===2" translate>lblMechanicComments
        </h4>
        <h4 class="modal-title" id="modal-basic-title" *ngIf="commentType===3" translate>lblCustomerCommets
        </h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')"><span
                aria-hidden="true">×</span></button>
    </div>
    <div class="modal-body table-responsive">
        <table class="tablest1">
            <thead>
                <tr>
                    <th translate>lblComment</th>
                    <th translate *ngIf="commentType != 3;">lblUser</th>
                    <th translate>lblCreatedDate</th>
                    <th translate *ngIf="commentType == 1;">lblAction</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngIf="commentType===1">
                    <ng-container *ngIf="commonService.internalComments.length > 0; else load_else_comments">
                        <tr *ngFor="let data of commonService.internalComments">
                            <td class="comment-cell">
                                <div class="comment-container">
                                    <div class="comment-content">
                                        {{data.comment}}
                                    </div>
                                </div>
                            </td>
                            <td>
                                {{data.user ? data.user : ''}}
                            </td>
                            <td>
                                {{data.updatedDate | date : 'short'}}
                            </td>
                            <ng-container>
                                <td>
                                    <a class="btn btn-ico" ngbTooltip="Edit" tooltipClass="custom-revert"
                                        (click)="EditComment(editContent,data)">
                                        <em class="fas fa-pencil-alt fa-lg"></em>
                                    </a>
                                    <a class="btn btn-ico" ngbTooltip="Delete" tooltipClass="custom-revert"
                                        (click)="DeleteComment(data)">
                                        <em class="far fa-trash-alt fa-lg"></em>
                                    </a>
                                </td>
                            </ng-container>
                        </tr>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="commentType===2">
                    <ng-container *ngIf="commonService.mechanicComments?.length > 0; else load_else_comments">
                        <tr *ngFor="let data of commonService.mechanicComments">
                            <td class="comment-cell">
                                <div class="comment-container">
                                    <div class="comment-content">
                                        {{data.comment}}
                                    </div>
                                </div>
                            </td>
                            <td>
                                {{data.user ? data.user : ''}}
                            </td>
                            <td>
                                {{data.updatedDate | date : 'short'}}
                            </td>
                        </tr>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="commentType===3">
                    <ng-container *ngIf="commonService.customerComments?.length > 0; else load_else_comments">
                        <tr *ngFor="let data of commonService.customerComments">
                            <td class="comment-cell">
                                <div class="comment-container">
                                    <div class="comment-content">
                                        {{data.comment}}
                                    </div>
                                </div>
                            </td>
                            <td>
                                {{data.updatedDate | date : 'short'}}
                            </td>
                        </tr>
                    </ng-container>
                </ng-container>
                <ng-template #load_else_comments>
                    <tr>
                        <td colspan="4" class="no-record" translate>lblNoRecordsFound</td>
                    </tr>
                </ng-template>
            </tbody>
        </table>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-lg" (click)="modal.close('Cancel click')"
            translate>lblCancel</button>
    </div>
</ng-template>